import axios from 'axios'
import {Message} from '@/utils/message'
import { emitLoginRequired } from '@/utils/loginModalBus'

const LOGIN_REQUIRED_CODE = 50001;

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded';



// 工具函数：设置 Cookie
function setCookie(name, value, hours) {
    const expires = new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=localhost; secure`;
}


// 工具函数：获取Cookie
function getCookie(name) {
    const matches = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return matches ? matches[2] : null;
}

// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        // 从本地存储或 Cookie 获取令牌
        const token = localStorage.getItem("lk-tk") || getCookie("lk-tk");
        if (token) {
            // 在请求头中携带令牌
            config.headers["lk-tk"] = token;
        }
        const lci = localStorage.getItem("l-c-i") || getCookie("l-c-i");
        if (lci) {
            // 在请求头中携带令牌
            config.headers["l-c-i"] = lci;
        }
        return config;
    },
    (error) => {
        // 处理请求错误
        console.error("Request error:", error);
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        const { data } = response || {};
        if (data?.code === LOGIN_REQUIRED_CODE) {
            emitLoginRequired();
        }
        // 从响应头获取 token（axios 会将 header 名称标准化，尝试多种可能的格式）
        const headers = response.headers;
        const newToken = headers["lk-tk"] || headers["Lk-Tk"] || headers["LK-TK"] || 
                         (() => {
                             // 如果上面的方式都不行，尝试遍历所有 header
                             for (let key in headers) {
                                 if (key.toLowerCase() === 'lk-tk') {
                                     return headers[key];
                                 }
                             }
                             return null;
                         })();
        if (newToken) {
            // 更新令牌到本地存储或 Cookie
            localStorage.setItem("lk-tk", newToken);
            setCookie("lk-tk", newToken, 10 / 24); // 设置有效期2小时
        }
        const lci = headers["l-c-i"] || headers["L-C-I"] || headers["L-C-I"] ||
                    (() => {
                        for (let key in headers) {
                            if (key.toLowerCase() === 'l-c-i') {
                                return headers[key];
                            }
                        }
                        return null;
                    })();
        if (lci) {
            // 更新令牌到本地存储或 Cookie
            localStorage.setItem("l-c-i", lci);
            setCookie("l-c-i", lci, 10 / 24); // 设置有效期2小时
        }
        // 统一处理响应数据
        return response; // 返回数据部分
    },
    (error) => {
        const code = error?.response?.data?.code;
        if (code === LOGIN_REQUIRED_CODE) {
            emitLoginRequired();
        }
        if (error.toString().indexOf('403') !== -1) {
            Message({
                message: '无权限操作.',
                type: 'error',
                duration: 5 * 1000
            })
        } else {
            return Promise.reject(error)
        }
    }
);
export default {
    // get请求
    requestGet(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, params).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error)
            });
        })
    },
    // post请求
    requestPost(url, params = {}, config = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, params, config).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error)
            })
        })
    },
    // delete请求
    requestDelete(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.delete(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        });
    },
    // put请求
    requestPut(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.put(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            });
        })
    }

}
